import { render } from "./Terms.vue?vue&type=template&id=55e02a4e"
import script from "./Terms.vue?vue&type=script&lang=js"
export * from "./Terms.vue?vue&type=script&lang=js"
script.render = render

export default script